import React from "react";
import { GrayDot } from "components/core";
import { COLOR_MAP, USER_TASK_STATUS_MAP } from "lib/constants";
import {
  FaRegDotCircle,
  FaRegCheckCircle,
  FaBan,
  FaRegTimesCircle,
} from "react-icons/fa";

const TASK_STATUS_INDICATOR_MAP = {
  CREATED: {
    Widget: (props) => (
      <FaRegDotCircle className={`emphasize blue ${props.className}`} />
    ),
    color: "blue",
    pos: "L",
  },
  DRAFT: {
    Widget: (props) => (
      <FaRegDotCircle className={`emphasize blue ${props.className}`} />
    ),
    color: "blue",
    pos: "L",
  },
  IN_PROGRESS: {
    Widget: (props) => (
      <FaRegDotCircle className={`emphasize blue ${props.className}`} />
    ),
    color: "blue",
    pos: "L",
  },
  COMPLETE: {
    Widget: (props) => (
      <FaRegCheckCircle className={`emphasize green ${props.className}`} />
    ),
    color: "green",
    pos: "R",
  },
  CANCELED: {
    Widget: (props) => <FaBan className={`emphasize ${props.className}`} />,
    color: "gray",
    pos: "R",
  },
  WONT_COMPLETE: {
    Widget: (props) => (
      <FaRegTimesCircle className={`emphasize ${props.className}`} />
    ),
    color: "gray",
    pos: "R",
  },
};

const StatusColumn = (props:any) => {
  let { status, size } = props;

  let title = "";
  let left = <GrayDot />;
  let middle = <GrayDot />;
  let right = <GrayDot />;
  let _color = "blue";
  let pos = "M";

  let Widget = (props) => <FaRegDotCircle className="emphasize blue" />;

  if (["COMPLETE", "COMPLETED"].includes(status)) {
    status = "COMPLETE";
  }
  if (["CANCELED", "CANCELLED"].includes(status)) {
    status = "CANCELED";
  }
    title = USER_TASK_STATUS_MAP[status]?.label || status;
    const info = TASK_STATUS_INDICATOR_MAP[status] || {};
    pos = info?.pos || "M";
    _color = COLOR_MAP[info?.color || "blue"];
    Widget = info?.Widget ?? Widget;
  
  if (pos === "L") {
    left = (
      <Widget className={`${size === "small" ? "emphasize-small" : ""}`} />
    );
  } else if (pos === "M") {
    middle = (
      <Widget className={`${size === "small" ? "emphasize-small" : ""}`} />
    );
  } else if (pos === "R") {
    right = (
      <Widget className={`${size === "small" ? "emphasize-small" : ""}`} />
    );
  }

  return (
    <>
      <div className="status-container">
        <div className="status-icon-container">
          {left}
          {middle}
          {right}
        </div>
        <div
          style={{ color: _color }}
          className={size === "small" ? "status-title-small" : "status-title"}
        >
          {title}
        </div>
      </div>
      <style>{`
        .status-container {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
  
        .status-icon-container {
          display: flex;
          align-items: center;
        }
  
        .gray-dot {
          height: 10px;
          width: 10px;
          margin: 4px;
          background-color: #d4d4d4;
          border-radius: 99999px;
        }
  
        .gray-dot-small {
          height: 5px;
          width: 5px;
        }
  
        .emphasize {
          height: 20px;
          width: 20px;
          font-size: 20px;
          margin: 4px;
          color: #d4d4d4;
        }
  
        .emphasize-small {
          height: 15px;
          width: 15px;
          font-size: 15px;
        }
  
        .blue {
          color: #2d4d77;
        }
  
        .green {
          color: #4caf50;
        }
  
        .red {
          color: #c61800;
        }
  
        .status-title {
          font-size: 0.75em;
          text-transform: uppercase;
        }
  
        .status-title-small {
          font-size: 0.60em;
          text-transform: uppercase;
        }
  
      `}</style>
    </>
  );
};

export default StatusColumn;
